import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';

export const Footer = () => (
  <footer className="bg-primary-700 text-white/80 mt-20">
    <div className="max-w-7xl mx-auto px-4 pt-14 pb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

        {/* Brand */}
        <div>
          <div className="mb-5">
            <p className="font-display font-semibold text-white text-xl leading-tight mb-0.5">Milan Medical</p>
            <p className="text-xs text-white/50 tracking-wider">Pharmacy & Health Store</p>
            <p className="gujarati text-white/50 text-xs mt-0.5">ફાર્મસી અને આરોગ્ય સ્ટોર</p>
          </div>
          <p className="text-sm leading-relaxed text-white/60 mb-6">
            Your trusted neighbourhood pharmacist in Nadiad since 1987. Quality medicines, expert guidance, and a familiar face every time.
          </p>
          <div className="flex gap-3">
            <SocialLink icon={Facebook}  href="#" />
            <SocialLink icon={Instagram} href="#" />
          </div>
        </div>

        {/* Shop */}
        <div>
          <p className="kicker text-white/40 mb-4">Shop</p>
          <ul className="space-y-2.5 text-sm">
            {SHOP_LINKS.map(({ label, to }) => (
              <li key={label}>
                <Link to={to} className="text-white/65 hover:text-white transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Help */}
        <div>
          <p className="kicker text-white/40 mb-4">Help</p>
          <ul className="space-y-2.5 text-sm">
            {HELP_LINKS.map(({ label, to }) => (
              <li key={label}>
                <Link to={to} className="text-white/65 hover:text-white transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <p className="kicker text-white/40 mb-4">Find Us</p>
          <ul className="space-y-3.5 text-sm">
            <li className="flex items-start gap-2.5">
              <MapPin className="h-4 w-4 text-sage shrink-0 mt-0.5" />
              <span className="text-white/65 leading-relaxed">Milan Medical, Station Road,<br />Nadiad, Gujarat — 387001</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="h-4 w-4 text-sage shrink-0" />
              <a href="tel:+912638000000" className="text-white/65 hover:text-white transition-colors">+91-2638-XXXXXX</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="h-4 w-4 text-sage shrink-0" />
              <a href="mailto:orders@milanmedical.in" className="text-white/65 hover:text-white transition-colors">orders@milanmedical.in</a>
            </li>
          </ul>
          <div className="mt-5 px-3.5 py-3 bg-white/5 rounded-md border border-white/10 text-xs text-white/40 space-y-0.5">
            <p>Drug License: DL-20B-GJ-XXXX</p>
            <p>Store hours: 8 am – 10 pm, Mon–Sat</p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/35">
        <p>© {new Date().getFullYear()} Milan Medical · Nadiad, Gujarat, India</p>
        <p>Schedule H drugs sold under licensed pharmacist supervision.</p>
      </div>
    </div>
  </footer>
);

const SocialLink = ({ icon: Icon, href }: { icon: React.ElementType; href: string }) => (
  <a href={href} className="w-8 h-8 rounded-md bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
    <Icon className="h-4 w-4 text-white/70" />
  </a>
);

const SHOP_LINKS = [
  { label: 'Medicines',           to: '/categories/medicines' },
  { label: 'Vitamins & Wellness', to: '/categories/vitamins-supplements' },
  { label: 'Ayurvedic & Herbal',  to: '/categories/ayurvedic-herbal' },
  { label: 'Skincare',            to: '/categories/skincare-beauty' },
  { label: 'Baby & Child',        to: '/categories/baby-child' },
  { label: 'Medical Devices',     to: '/categories/medical-devices' },
];

const HELP_LINKS = [
  { label: 'Upload Prescription',      to: '/prescriptions' },
  { label: 'Track Your Order',         to: '/orders' },
  { label: 'Milan Circle Rewards',     to: '/profile/loyalty' },
  { label: 'Drug Interaction Checker', to: '/drug-checker' },
  { label: 'Symptoms Guide',           to: '/symptoms' },
  { label: 'About Us',                 to: '/about' },
];
